import { render, staticRenderFns } from "./FormInputCheck.vue?vue&type=template&id=76a07659"
import script from "./FormInputCheck.vue?vue&type=script&lang=js"
export * from "./FormInputCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports